// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rJIdW","col":"styles_col__3np5S"};